exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-field1 {\n  width: 170px;\n}\n.label-field2 {\n  width: 200px;\n}", ""]);

// exports
